import { packBigNumbers } from '@/lib/BigNumbers';
import { StateFilter } from '@/lib/filter/stakingPoolState';
import { PoolListType } from '@/types';
import { Box, Typography, useTheme } from '@mui/material';

export default function ExplainDetail({ detail }: { detail: PoolListType }) {
  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '8px',
          borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
        }}
      >
        <Typography variant="body2" color={theme.greyscale.grey1}>
          Target Amount (Min)
        </Typography>

        <Box sx={{ textAlign: 'right' }}>
          <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
            {packBigNumbers(detail.goalUsdt)}{' '}
            <Typography display={'inline'} variant="body4" color={theme.greyscale.darkgrey2}>
              USD
            </Typography>
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '8px',
          borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
        }}
      >
        <Typography variant="body2" color={theme.greyscale.grey1}>
          APR
        </Typography>

        <Box sx={{ textAlign: 'right' }}>
          <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
            {detail.interestRate}%
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '8px',
          borderBottom: `0.5px solid ${theme.greyscale.lightgrey2}`,
        }}
      >
        <Typography variant="body2" color={theme.greyscale.grey1}>
          Minimum Deposit
        </Typography>

        <Box sx={{ textAlign: 'right' }}>
          <Typography variant="subtitle2" color={theme.greyscale.darkgrey2}>
            {packBigNumbers(detail.minUsdt)}{' '}
            <Typography display={'inline'} variant="body4" color={theme.greyscale.darkgrey2}>
              USD
            </Typography>
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '8px',
        }}
      >
        <Typography variant="body2" color={theme.greyscale.grey1}>
          Pool Status
        </Typography>

        <Box sx={{ textAlign: 'right' }}>
          <Typography variant="subtitle2" color={theme.background.blue}>
            {StateFilter(detail.state)}
          </Typography>
        </Box>
      </Box>
    </>
  );
}
